<template>
  <div>
    <div v-if="ready">
      <div class="row m-b-lg m-t-lg wrapper">
        <div class="col-md-12">
          <h3>
            {{ registrar.name }}
          </h3>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Name</td>
                  <td>
                    <e-txt
                      :locked="!registrar.real"
                      type="editable"
                      :text="registrar.name"
                      @input="updateProperty($event, 'name')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Client</td>
                  <td>
                    <v-select
                      :disabled="!registrar.real || !(user.admin || user.clients.length > 0)"
                      :options="user.admin ? f.clients : f.clients.filter(c => user.clients.map(uc => uc.id).includes(c.id))"
                      label="name"
                      index="id"
                      v-model="client"
                      @input="updateProperty($event, 'client')">
                    </v-select>
                  </td>
                </tr>
                <tr v-if="registrar.real">
                  <td>Last import</td>
                  <td>
                    {{ registrar.import | aTime('from') }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr v-if="registrar.real">
                  <td>Integration</td>
                  <td>
                    <v-select
                      :options="Object.keys(f.registrarIntegrations || {})"
                      v-model="integration"
                      @input="updateProperty($event, 'integration')">
                    </v-select>
                  </td>
                </tr>
                <tr
                  v-if="integration"
                  v-for="integrationAuth in authKeys"
                  :key="integration + integrationAuth"
                  :set="secret = ['secretKey'].includes(integrationAuth)">
                  <td>{{ integrationAuth | integrationAuthFriendly }}</td>
                  <td>
                    <span v-if="integrationAuth === 'file'">
                      <input type="file" name="" id="" class="pull-left" ref="exportedFile" @change="setFile($event.target.name, $event.target.files)">
                      <button class="btn btn-xs btn-success pull-right" @click="importCsv">Import</button>
                    </span>
                    <e-txt
                      v-else
                      type="editable"
                      :text="registrar.integration.credentials[integrationAuth]"
                      @input="updateProperty($event, integrationAuth)"
                      close-on-save="true"
                      sensitive="true"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Health: </td>
                  <td>
                    <i class="fa fa-warning red" v-tooltip="'Failing!'" v-if="registrar.failed"></i>
                    <i class="fa fa-check green" v-tooltip="'Working just fine!'" v-else></i>
                    <a v-tooltip="'Remove Failing Flag'" v-if="registrar.failed" @click="updateProperty(false, 'failed')"><i class="fa fa-trash-o pull-right"></i></a>
                  </td>
                </tr>
                <tr v-if="registrar.integration && authKeys.length && !authKeys
                .map(k => !registrar.integration.credentials[k])
                .reduce((acc, cur) => acc ? acc : cur, false)"
                >
                  <td></td>
                  <td>
                    <button class="btn btn-xs btn-primary pull-right" @click="importDomains">{{ importButtonText }}</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Url</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="registrar.login.url"
                      @input="updateProperty($event, 'login.url')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Username</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="registrar.login.user"
                      @input="updateProperty($event, 'login.user')"
                      close-on-save="true"
                      sensitive="true"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Password</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="registrar.login.pass"
                      @input="updateProperty($event, 'login.pass')"
                      close-on-save="true"
                      sensitive="true"
                    ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import EditText from '../../../Helpers/Form/EditText'
import axios from 'axios'
import { REGISTRAR_LIST_SET } from '../../../../store/mutation-types'
import { eventBus } from '../../../../main'

export default {
  data () {
    return {
      importButtonText: 'Import',
      csvFile: null
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      user: 'getUser',
      registrars: 'getRegistrars'
    }),
    registrar: ({$route, $store}) => {
      const registrar = $store.state.registrarList.find(r => r.id === $route.params.id)
      return registrar || {integration: {credentials: {}}}
    },
    client: { get ({ registrar }) { return registrar.client ? registrar.client.id : null }, set () {} },
    integration: {
      get ({ f, registrar }) {
        return registrar.integration ? registrar.integration.name : null
      },
      set () {
      }
    },
    authKeys: {
      get ({ f, registrar }) {
        if (registrar.integration && registrar.integration.name && f.registrarIntegrations) {
          return f.registrarIntegrations[registrar.integration.name]['auth']
        }
        return []
      },
      set () {}
    },
    ready: ({ registrar, f }) => {
      return registrar.name && f.registrarIntegrations
    }
  },
  components: {
    eTxt: EditText
  },
  mounted () {
    this.$store.state.registrarList.length === 0 && this.$store.dispatch('loadRegistrars')
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    document.title = `${this.registrar.name || ''} :: Registrars :: PBN360 by Aphex Media`
  },
  filters: {
    fromNow: ts => ts && ts.date ? moment(ts.date).fromNow() : '',
    integrationAuthFriendly: key => {
      switch (key) {
        case 'apiKey':
          return 'API Key'
        case 'secretKey':
          return 'API Secret'
        case 'file':
          return 'File'
        default:
          return key
      }
    }
  },
  methods: {
    updateProperty (val, prop) {
      let data = {}
      data[prop] = val

      if (prop === 'integration') {
        data['apiKey'] = null
        data['secretKey'] = null
      }

      axios.patch(`/registrar/${this.registrar.id}`, data)
        .then(r => {
          if (r.data.error) return this.$toastr.error(r.data.error, 'Unable to update')

          const registrar = r.data.data
          this.$toastr.success(`${prop} updated successfully`, 'Good')
          this.$store.commit(REGISTRAR_LIST_SET, this.$store.state.registrarList.map(r => r.id === registrar.id ? registrar : r))
          this.$forceUpdate()
        })
        .catch(e => {
          this.$toastr.error(e, 'Unable to update')
        })

      return true
    },
    importDomains () {
      axios.get(`/registrar/import/${this.registrar.id}`)
        .then(r => {
          this.$toastr.success(`Successfully imported ${r.data.updated} domains`, 'Good')
          const registrar = {...this.registrar}
          registrar.domainCount = r.data.updated
          registrar.import = r.data.timestamp
          this.$store.commit(REGISTRAR_LIST_SET, this.$store.state.registrarList.map(r => r.id === registrar.id ? registrar : r))
          eventBus.$emit('reloadRegistrarDomains')
        })
        .catch(e => {
          this.$toastr.error(e, 'Unable to update')
        })
    },
    setFile (name, file) {
      this.csvFile = file
    },
    importCsv () {
      const formData = new FormData()
      formData.append('fileImport.csv', this.csvFile[0])
      axios.post(`/registrar/import/${this.registrar.id}`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(r => {
          this.$toastr.success(`Successfully imported ${r.data.updated} domains`, 'Good')
          const registrar = {...this.registrar}
          registrar.domainCount = r.data.updated
          registrar.import = r.data.timestamp
          this.$store.commit(REGISTRAR_LIST_SET, this.$store.state.registrarList.map(r => r.id === registrar.id ? registrar : r))
          this.$emit('reloadRegistrarDomains')
        })
        .catch(e => {
          this.$toastr.error(e, 'Unable to update')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Accounts/Registrar/Header.vue